import Main from '@/views/main.vue';

export const quotaApplication = {
    path: '/comprehensive',
    name: 'comprehensive',
    title: '综合管理',
    component: Main,
    children: [{
        path: 'report_traffic',
        title: '报表中心',
        name: 'report_traffic',
        component: () =>
            import ('@/views/home/homeContainer.vue'),
        children: [{
            path: 'traffic_wisdom_j',
            title: '智慧监测平台',
            name: 'traffic_wisdom_j',
            component: () =>
                import ('@/views/system/traffic/wisdomJ/wisdom.vue'),
        }, ]
    }, ]
}


// WEBPACK FOOTER //
// ./src/router/childrenRouter/quotaApplication.js